import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/**
 * views/supplier-bills/capital-amount/form PUTs
 * `{name, note, capital_amount_type_id}`. `amount` is create-only, so `balance`
 * stays read-only. `capital_amount_type_id` has no column, so it keeps its
 * value from the detail rather than gaining a pencil.
 */
export default defineInlineEdit({
  api: "capitalAmount",
  permission: "capital_amount_edit",
  hydrate: true,
  toPayload: (detail) => ({
    name: detail.name ?? "",
    note: detail.note ?? "",
    capital_amount_type_id:
      detail.capital_amount_type_id ?? detail.capital_amount_type?.id,
  }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
    note: { label: "الملاحظة", type: "text" },
  },
});
